module.exports = __webpack_public_path__ + "img/Toolkit.eacb4b6d.svg";